function omit(source) {
  const copiedSource = {
    ...source
  };
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }
  values.forEach(value => {
    delete copiedSource[value];
  });
  return copiedSource;
}
export { omit };